import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import { Sparkles, Home, Users, MessageCircle } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";
import { photoUrl } from "@/lib/api";

const tabs = [
    { to: "/app/match", label: "Match", icon: Sparkles, testId: "tab-match" },
    { to: "/app/flats", label: "Flats", icon: Home, testId: "tab-flats" },
    { to: "/app/roommates", label: "Roommates", icon: Users, testId: "tab-roommates" },
    { to: "/app/chat", label: "Chat", icon: MessageCircle, testId: "tab-chat" },
];

export default function BottomNav() {
    const { user } = useAuth();
    const location = useLocation();
    // Hide the floating nav inside a chat room so it never covers the message composer.
    if (/^\/app\/chats\//.test(location.pathname)) return null;
    const avatarSrc = user?.picture || (user?.photos?.[0] ? photoUrl(user.photos[0]) : null);
    const initial = (user?.name || "?").trim().charAt(0).toUpperCase();

    return (
        <nav
            className="fixed bottom-3 left-1/2 -translate-x-1/2 z-50 w-[min(96%,520px)]"
            data-testid="bottom-nav"
        >
            <div className="flex items-center justify-around gap-0.5 rounded-full border-2 border-foreground bg-card/90 backdrop-blur-xl px-1.5 py-2 shadow-[0_10px_40px_-10px_rgba(139,92,246,0.45)]">
                {tabs.map((t) => (
                    <NavLink
                        key={t.to}
                        to={t.to}
                        data-testid={t.testId}
                        className={({ isActive }) =>
                            `flex flex-col items-center gap-0.5 px-2 py-2 rounded-full text-[10px] font-black uppercase tracking-wider min-w-[52px] ${
                                isActive ? "text-primary-foreground bg-primary" : "text-muted-foreground hover:text-foreground"
                            }`
                        }
                    >
                        <t.icon className="h-5 w-5" strokeWidth={2.5} />
                        <span className="text-[9px]">{t.label}</span>
                    </NavLink>
                ))}
                <NavLink
                    to="/app/menu"
                    data-testid="tab-menu"
                    className={({ isActive }) =>
                        `group flex flex-col items-center gap-0.5 px-1.5 py-1.5 rounded-full text-[10px] font-black uppercase tracking-wider min-w-[52px] ${
                            isActive ? "text-primary" : "text-muted-foreground hover:text-foreground"
                        }`
                    }
                >
                    <div
                        className="h-8 w-8 rounded-full overflow-hidden grid place-items-center border-2 border-transparent group-[.active]:border-primary bg-accent text-accent-foreground font-black"
                        data-testid="menu-avatar"
                    >
                        {avatarSrc ? (
                            <img src={avatarSrc} alt="me" className="h-full w-full object-cover" />
                        ) : (
                            <span>{initial}</span>
                        )}
                    </div>
                    <span className="text-[9px]">Menu</span>
                </NavLink>
            </div>
        </nav>
    );
}
